/**
 * Gooval Open API HMAC signing (dev/debug only — production must sign on the server).
 * Signature: hex(hmac_sha256(secret, store_number + "\n" + timestamp + "\n" + raw_body))
 */

export async function hmacSha256Hex (secret, message) {
  const enc = new TextEncoder()
  const key = await crypto.subtle.importKey(
    'raw',
    enc.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(message))
  return Array.from(new Uint8Array(sig))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export function buildSignaturePayload (storeNumber, timestamp, rawBody) {
  return `${storeNumber}\n${timestamp}\n${rawBody}`
}

export function unixTimestampSeconds () {
  return String(Math.floor(Date.now() / 1000))
}

export function newIdempotencyKey () {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `idem-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}
